import {IStore} from "modules/store";
import {createSelector} from "@reduxjs/toolkit";

const getState = ({modal}: IStore) => modal;

export const getErrorModalMessage = createSelector(getState, (state) => state.errorModalMessage);
export const getIsTutorialModalOpen = createSelector(
	getState,
	(state) => state.isTutorialModalOpen
);
export const getIsGameOverModalOpen = createSelector(
	getState,
	(state) => state.isGameOverModalOpen
);
export const getIsTutorialViewed = createSelector(getState, (state) => state.isTutorialViewed);
